import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../components/Pagination";
import api from "../api/api";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./Freight/Common/form.css";
import Breadcrumbs from "../components/Breadcrumbs";
import usePagination from "../utils/usePagination";
import Table from "../components/table";

const Warehouse = () => {
  const [warehouse, setWarehouse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(warehouse, 5);

  // Fetch warehouse data
  useEffect(() => {
    const fetchWarehouse = async () => {
      setLoading(true);
      try {
        const response = await api.get("/warehouse/request-list");
        setWarehouse(response?.data?.requests || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch warehouse data");
        // Keep warehouse as empty array so table renders
        setWarehouse([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWarehouse();
  }, []);

  const columns = [
    { label: "Customer Name", accessor: "customer_name" },
    {
      label: "Customer Mobile No.",
      accessor: "customer_phoneNo",
    },
    { label: "Product Name", accessor: "product_name" },
    { label: "Storage Type", accessor: "storage_type" },

    {
      label: "Action",
      render: (item) => (
        <Link to={`/warehouse-request-responses/${item.id}`}>
          <ArrowForwardIcon />
        </Link>
      ),
    },
  ];

  return (
    <>
      <Breadcrumbs />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Warehouse Requests Found"
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};

export default Warehouse;
